import baseService from './baseService';
import { HOST } from './../utils/config';
import colorApi from './color.js';
class InfoService extends baseService {
  static getShopOrganizationInfo (vendorId, publishSource = '', orgIdType = '', productFlag = true) {
    return colorApi('paimai_getShopOrganizationInfo', {
      vendorId,
      addSearchHistoryFlag: false, // 是否添加查询历史
      publishSource,
      orgIdType,
      productFlag // 是否带拍品列表
    })
    // return this.axiosMethod('get', 'paimai', 'paimai_getShopOrganizationInfo', {
    //   vendorId,
    //   addSearchHistoryFlag: false, // 是否添加查询历史
    //   publishSource,
    //   orgIdType,
    //   productFlag // 是否带拍品列表
    // })
  }

  //公告数量(vendorId 使用)
  static getNoticeNum(params) {
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=paimai_getShopNoticeList&body=${JSON.stringify(params)}`)
  }

  //公告数量(customs 使用)
  static getNoticeNumByCustoms(params) {
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=getCountForCustomsHomeJsf&body=${JSON.stringify(params)}`)
  }

  //分享海报-类目
  static getShopNewestCategory(params) {
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=paimai_getShopNewestCategory&body=${JSON.stringify(params)}`)
  }

  //不同业务线类目
  static getCategoryByPublishSource(params){
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=paimai_getCustomSearchCategory&body=${JSON.stringify(params)}`)
  }

  // 获取banner数据
  static getAdData(params) {
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=getOrgOrVendorAdData&body=${JSON.stringify(params)}`)
  }




}

export default InfoService